import React from "react";
import { useTranslation } from "react-i18next";
import { GoalClockIcon } from "@/apps/goals/assets/icons";
import { GoalHeroStripes } from "@/apps/goals/components/GoalHeroStripes/GoalHeroStripes";
import { GoToParkButton } from "@/apps/goals/components/NextGoalButton/GoToParkButton";
import { GoalProgressBlock } from "@/apps/goals/components/GoalProgressBlock/GoalProgressBlock";
import { NextGoalCard } from "@/apps/goals/components/NextGoalCard/NextGoalCard";
import { ShareButton } from "@/apps/goals/components/ShareButton/ShareButton";
import { useCurrentGoalData } from "@/apps/goals/hooks/useCurrentGoalData";
import { useGoalParkTitle } from "@/apps/goals/hooks/useGoalParkTitle";
import Typography from "@/ui/Typography/Typography";
import { useTimeLeft } from "@/apps/goals/hooks/useTimeLeft";
import { formatGoalRewardAmount } from "@/apps/goals/utils/formatTime";
import { useShareGoal } from "@/apps/goals/hooks/useShareGoal";
import cls from "./styles.module.scss";

export const GoalCompletedPage = () => {
  const { t } = useTranslation();
  const goalParkTitle = useGoalParkTitle();

  const {
    rewardAmount,
    ridesRequired,
    completedRides,
    expiresAt,
  } = useCurrentGoalData(true);
  const timeLeft = useTimeLeft(expiresAt ?? Date.now());
  const shareGoal = useShareGoal();

  return (
    <section className={cls.root}>
      <div className={cls.content}>
        <div className={cls.hero}>
          <GoalHeroStripes />
          <img
            className={cls.targetIcon}
            src="/goals/target_green.webp"
            alt=""
          />
        </div>
        <div className={cls.timeBadge}>
          <GoalClockIcon color="var(--text-secondary)" />
          <Typography
            component="span"
            size="md"
            weight="semibold"
            family="Onest"
          >
            {t("goals.active.completed")}
          </Typography>
        </div>
        <div className={cls.copy}>
          <Typography component="p" size="md" weight="bold">
            {goalParkTitle}
          </Typography>
          <Typography
            className={cls.goal}
            component="h1"
            size="2xl"
            weight="bold"
            family="custom"
          >
            {t("goals.active.completedReward", {
              price: formatGoalRewardAmount(rewardAmount),
            })}
          </Typography>
        </div>
        <GoalProgressBlock
          completedRides={completedRides}
          ridesRequired={ridesRequired}
          variant="completed"
        />
        <ShareButton
          variant={timeLeft > 0 ? "primary" : "graphite"}
          onClick={() =>
            shareGoal({
              variant: "completed",
              rewardAmount,
              ridesRequired,
            })
          }
        />
        <NextGoalCard startsAt={expiresAt} />
        <GoToParkButton />
      </div>
    </section>
  );
};
